// --------------------------------------------------------------------------
// Rendered when returning a single result
// --------------------------------------------------------------------------

import React from 'react';
import lookup from './words.js';
import styles from './index.module.css';
import event from '../../helpers/event.js'

// --------------------------------------------------------------------------

class SingleResult extends React.Component {

    // ----------------------------------------------------------------------

    render() {
        
        // import or default URLs for links and images
        const baseURL = this.props.baseURL || 'https://www.laithwaites.co.uk';
        const productURLTemplate = this.props.productURL || '/product/{sku}';
        const tastingNotesURLTemplate = this.props.tastingNotesURL || '/product/{sku}';
     
        const wine = this.props.wine;
        
        const name = wine.name;
        const vintage = wine.vintage;
        const prefix = baseURL; // same as baseURL!
        const thumbnailImage = [prefix,wine.thumbnailImage].join('');

        const productId = wine.productId;

        // calculate URLs
        const productURL = `${baseURL}${productURLTemplate}`.replace('{sku}', productId);
        const tastingNotesURL = `${baseURL}${tastingNotesURLTemplate}`.replace('{sku}', productId);

        return (
            <div className={styles.bsSingleResultPage}>
                <div className={styles.bsHeader}>
                    <h1>{lookup('headingSingleResult')}</h1>
                    <p>{name} {vintage}</p>
                </div>
                <div className={styles.bsCenter}>
                    <img src={thumbnailImage} />
                </div>
                <div className={styles.bsFooter}>
                    <button className={styles.bsExternalNavButton} onClick={ (e) => { 
                        // Fire an event to GA
                        event('Bottle Scanner', 'Click', 'View product page and buy');
                        window.location.assign( productURL ) } }>{lookup('buttonViewProductPage')}</button>
                    <button className={styles.bsExternalNavButton} onClick={ (e) => { 
                        // Fire event to GA
                        event('Bottle Scanner', 'Click', 'Go beyond the label');
                        window.location.assign( tastingNotesURL ) } }>{lookup('buttonViewTastingNotes')}</button>
                    { this.props.onNotThisWine!=null ? <button className={styles.bsInternalNavButton} onClick={ (e) => { this.props.onNotThisWine(); } }>{lookup('buttonReselectWine')}</button> : null }
                    <button className={styles.bsInternalNavButton} onClick={ (e) => { this.props.onTryAgain(); } }>{lookup('buttonTryAgain')}</button>
                </div>
            </div>
        )
    }

}

// --------------------------------------------------------------------------

export default SingleResult;

// --------------------------------------------------------------------------
